import {
  type InmateActivity,
  type InmateActivitySummary,
} from '@reliance/types/models/InmateActivity';
import { type CommissaryTransfer } from '@reliance/types/models/CommissaryTransfer';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService, type QueryParams } from '../types/ApiService';

export const inmateAccount = (siteApi: ApiService, centralApi: ApiService) => ({
  activity: {
    index: (params): Promise<PaginatedResponse<InmateActivity>> => {
      return centralApi.get('/inmate-account/activity', { params });
    },
    post: (data) => {
      return siteApi.post('/inmate-account/activity', data);
    },
  },
  audioVideoSummary: (
    params = {},
  ): Promise<PaginatedResponse<InmateActivitySummary>> => {
    return centralApi.get('/inmate-account/audio-video/summary', { params });
  },
  summary: (params = {}): Promise<PaginatedResponse<InmateActivitySummary>> => {
    return centralApi.get('/inmate-account/summary', { params });
  },
  commissaryTransfer: {
    index: (
      params: QueryParams = {},
    ): Promise<PaginatedResponse<CommissaryTransfer>> => {
      return centralApi.get('/inmate-account/commissary-transfer', { params });
    },
    post: function (data) {
      return centralApi.post('/inmate-account/commissary-transfer', data);
    },
    delete: function (id, description) {
      return centralApi.delete(`/inmate-account/commissary-transfer/${id}`, {
        params: { description },
      });
    },
  },
  loadPhoneCard: {
    post: function (data) {
      return siteApi.post('/inmate-account/load-phone-card', data);
    },
  },
});
